import { Component } from "react";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";
import Icons from "../../../../icon";
export class DetailsDataTable extends Component {
    constructor(props){
        super(props);
        this.state={
            showUpdateBtn:false
        }
    }
    ShowUpdateBtn(){
        this.setState({showUpdateBtn:true})
    }
    HideUpdateBtn(){
        this.setState({showUpdateBtn:false})
    }
    render(){       
        return(
            <div className={this.props.classNameWrapper}>
                <table className="details-view-table">
                    <thead>
                        <tr>
                            { this.props.datatable.map((item)=>

                                item.HeaderItem.map((header,key)=>(                                
                                header.name && <th key={key}>
                                        {header.name}
                                    </th>                                
                                ))
                            
                            )}
                            {this.props.haveToggle && 
                                <>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Execute</th>
                                </>
                            }                           
                        </tr>                        
                    </thead>
                   
                    <tbody >
                    { this.props.datatable.map((item)=>

                        item.dataItem.map((dataItem,itemKey)=>(                                   
                            <tr key={itemKey}>
                                {Object.keys(dataItem).map((detail,keyId) => (
                                    <td key={keyId} value={detail} id={keyId} onClick={this.getDataOnTable} >{dataItem[detail]}</td>
                                ))}
                                {this.props.haveToggle && 
                                    <>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                    </>                                    
                                }
                                {
                                    (this.props.haveDeleteBtn ||  this.props.haveEditBtn) &&
                                    <td className="edit-btn-container">  
                                        {
                                            this.state.showUpdateBtn ?
                                            <>
                                                <Icons
                                                customClassName="icon-xmark-reg"
                                                name="xmark"
                                                size="20px"
                                                containerClass="icon-circle-plus-container"
                                                onClick={this.HideUpdateBtn.bind(this)}
                                                /> 
                                                <Icons
                                                    customClassName="icon-check-reg"
                                                    name="check"
                                                    size="20px"
                                                    containerClass="icon-circle-plus-container"
                                                    onClick={()=>alert("Code Here")}
                                                /> 
                                            </>
                                            :
                                            <>
                                            {this.props.haveDeleteBtn &&
                                                <Icons
                                                    customClassName="icon-trash"
                                                    name="trash-can"
                                                    size="20px"
                                                    containerClass="icon-circle-plus-container"
                                                    onClick={()=>alert("Code Here")}
                                                />
                                            }                                              
                                        
                                            {this.props.haveEditBtn &&
                                                <Icons
                                                    customClassName="icon-pen-light"
                                                    name="pen-light"
                                                    size="20px"
                                                    containerClass="icon-circle-plus-container"
                                                    onClick={this.ShowUpdateBtn.bind(this)}
                                                />
                                            }  
                                            </>

                                        }
                                                                               
                                    </td>                                     
                                }                                                            
                            </tr>
                        ))

                    )}
                    </tbody>                    
                </table>
                 {/* Delete */}
                 
                 <div className="delete-buttons-container">
                        {this.props.haveExternalDeleteBtn &&
                        this.props.datatable.map((item, index) => (
                            item.dataItem.map((listItem,indexItem)=>
                                <div key={indexItem} className="delete-button-row">
                                <Icons
                                    customClassName="icon-trash"
                                    name="trash-can"
                                    size="20px"
                                    containerClass="icon-circle-plus-container"
                                    onClick={() => alert("Delete code here")}
                                />
                                </div>
                            )
                        ))}
                 </div>
            </div>
        );
    }
}